.LoadingWrapper {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-top: 20px;

  .tableLine {
    display: grid;
    grid-template-columns: 26px minmax(0, 1.2fr);
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    padding: 0px 12px 0px 8px;

    .skeletons {
      display: flex;
      flex-direction: column;
      row-gap: 40px;
    }

    & > :nth-child(n + 3) {
      justify-self: end;
    }
  }
}
